import { useEffect, useState, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";
import {
  Button,
  createStyles,
  Grid,
  makeStyles,
  IconButton,
  Box,
  TextField,
  Theme,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { CircularProgress } from "../../components/reusable/circularProgress";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import {
  getNewRequest_toolAction,
  submitDataAction,
  getApproversAction,
  gettAttachmentDownloadFileAction,
  postAttachmentToRequestIdAction,
  postAttachmentToTempFolderAction,
  postAttachmentToMoveFileAction,
  succespostAttachmentMoveFileAction,
  postAttachmentDeleteFileAction,
  updateDisposalRequestAction,
  succespostAttachmentDownloadFileAction,
} from "../toolDisposalSlice";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { v4 as uuidv4 } from "uuid";
import { CentralLoader } from "./centralLoaderModal";
import { RequestHeader } from "./newRequestHeader";
import { useAppData } from "../../services/hooks";
import { IAttachments } from "../../services/generated/ApiClientGenerated";
import { businessUnit, eolToolingApprover, toolSelectOptions, pgaToolingApprover } from "../../constants/toolConstant";
let FileSaver = require("file-saver");

export const LeftSection = ({
  paramsData,
  requester,
  statusSubmit,
}): JSX.Element => {
  const history = useHistory();
  const classes = useStyles();
  const toolValue = useAppData(
    (r) => r.toolDisposalSlice.toolInformation.toolValue
  );
  const attachmentsResponse = useAppData((r) =>
    r.toolDisposalSlice.attachmentsResponse.originalAttachmentValue
      ? r.toolDisposalSlice.attachmentsResponse.originalAttachmentValue
      : ""
  );
  const moveAttachmentResponse = useAppData((r) =>
    r.toolDisposalSlice.attachmentsResponse.moveAttachmentValue
      ? r.toolDisposalSlice.attachmentsResponse.moveAttachmentValue
      : ""
  );
  const deleteAttachmentResponse = useAppData((r) =>
    r.toolDisposalSlice.attachmentsResponse.deleteAttachmentValue
      ? r.toolDisposalSlice.attachmentsResponse.deleteAttachmentValue
      : ""
  );
  const downloadAttachmentValue = useAppData((r) =>
    r.toolDisposalSlice.attachmentsResponse.downloadAttachmentValue
      ? r.toolDisposalSlice.attachmentsResponse.downloadAttachmentValue
      : ""
  );
  const isAttachLoading = useAppData(
    (r) => r.toolDisposalSlice.attachmentsResponse.loading
  );

  const approversValue = useAppData(
    (r) => r.toolDisposalSlice.approvers.approversValue
  );
  const row = useAppData((r) => r.toolDisposalSlice.updateValues.value);
  const updateCreateToolResponse = useAppData(
    (r) => r.toolDisposalSlice.updateCreateToolResponse.requestId
  );
  const validationStatus = useAppData((r) => r.global.validationStatus.isInvalid);

  let attachmentRowData = row?.attachments ? row.attachments.attachment : [];

  const header = "REQUEST INFORMATION";
  const headerApprovers = "APPROVERS";
  const headerAttachments = "ATTACHMENTS";
  const location = useLocation();
  const [bindingData, setBindingData] = useState({});
  const [arrayAttachment, setArrayAttachment] = useState([]);
  const [attachment, setAttachment] = useState({});
  const [guiID, setGuiID] = useState({});
  const [deletdAttachment, setDeletdAttachment] = useState(null);
  const [modalActive, setModalActive] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [toolSelectOption, setToolSelectOption] = useState("notSelected");

  const dispatch = useDispatch();
  useEffect(() => {
    let tempRequestId: any = uuidv4();
    setGuiID(tempRequestId);
  }, []);

  useEffect(() => {
    if (downloadAttachmentValue != "") {
      FileSaver.saveAs(downloadAttachmentValue);
    }
    dispatch(succespostAttachmentDownloadFileAction(""));
  }, [downloadAttachmentValue]);

  useEffect(() => {
    if (attachmentsResponse != "") {
      let splitAttachments = attachmentsResponse.split("/");
      let AttachmentRow: any = {
        attachmentName: splitAttachments[2],
        fileAbsoluteUrl: attachmentsResponse,
      };
      setAttachment(AttachmentRow);
    }
  }, [attachmentsResponse]);

  useEffect(() => {
    handleAttachments(attachment);
  }, [attachment]);

  const createTagHandler =
    (
      tagType:
        | "requester"
        | "businessUnit"
        | "approverManagers"
        | "reasonForRequest"
        | "toolNumber"
        | "toolNumberWrite"
        | "handleToolDescriptionStatic"
        | "toolDescription"
        | "attachments"
        | "toolNumberStatic"
    ) =>
    (value: any) => {
      const { ...rowdata } = row;
      if (tagType === "toolNumber") {
        dispatch(
          submitDataAction({
            body: {
              ...rowdata,
              ...bindingData,
            },
          })
        );
      } else if (tagType === "toolNumberStatic") {
        dispatch(
          submitDataAction({
            body: {
              ...rowdata,
              toolNumber: value[0],
              toolDescription: value[1],
            },
          })
        );
      } else if (tagType === "toolNumberWrite") {
        dispatch(
          submitDataAction({
            body: {
              ...rowdata,
              toolNumber: value,
            },
          })
        );
      } else if (tagType === "toolDescription") {
        dispatch(
          submitDataAction({
            body: {
              ...rowdata,
              toolDescription: value,
            },
          })
        );
      } else if (tagType === "attachments") {
        if (row?.attachments && row?.attachments?.attachment?.length > 0) {
          dispatch(
            submitDataAction({
              body: {
                ...rowdata,
                attachments: {
                  attachment: [...row.attachments.attachment, attachment],
                },
              },
            })
          );
        } else {
          dispatch(
            submitDataAction({
              body: {
                ...rowdata,
                attachments: {
                  attachment: [attachment],
                },
              },
            })
          );
        }
      } else {
        dispatch(
          submitDataAction({
            body: {
              ...rowdata,
              [tagType]: value,
            },
          })
        );
      }
    };

  const handleToolNumberWrite = createTagHandler("toolNumberWrite");
  const handleBusinessUnit = createTagHandler("businessUnit");
  const handleAttachments = createTagHandler("attachments");
  const handleToolNumber = createTagHandler("toolNumber");
  const handleToolNumberStatic = createTagHandler("toolNumberStatic");
  const handleToolDescriptionStatic = createTagHandler("toolDescription");
  const handleReasonForRequest = createTagHandler("reasonForRequest");
  const [indexAttachment, setIndexAttachment] = useState(0);
  const [sourcingValue, setSourcingValue] = useState(null);
  const [engineeringManagerValue, setEngineeringManagerValue] = useState(null);
  const [pGApproverValue, setPGApproverValue] = useState<any>(null);
  const [eolToolingSelectValue, setEolToolingSelectValue] = useState<any>(null);

  function handleFilterChange(options: any) {
    let newToolValuFiltered = toolValue.filter((obj) => {
      return obj.toolNumber === options.toolNumber;
    });
    let data = newToolValuFiltered[0];

    let newToolBindingData = {
      supplierName: data.vendorName,
      supplierNumber: data.vendorNo,
      poNumber: data.toolValue.value,
      productLines: data.productGroup,
      countryToolResidesIn: data.toolLocation.country,
      stateToolResidesIn: data.toolLocation.state,
      toolTypeId: data.toolTypeId,
      toolType: data.toolType,
      totalPOValue: data.toolValue.poActualAmount,
      projectNumber: data.projectNumber,
      toolNumber: data.toolNumber,
      toolDescription: data.toolDescription,
    };

    setBindingData(newToolBindingData);
  }

  let attachmentsArray: any = row?.attachments?.attachment?.map((e) => {
    return {
      tempRequestId: `temprequestid-${guiID}`,
      originalRequestId: updateCreateToolResponse,
      fileName: e.attachmentName,
      action: "movetempfile",
    };
  });

  const handleClose = () => {
    setModalActive(false);
    setModalOpen(false);
  };

  useEffect(() => {
    const attachmentMove = () => {
      if (
        attachmentsArray &&
        attachmentsArray.length > 0 &&
        attachmentsArray.length + 1 > indexAttachment &&
        row?.attachments?.attachment?.[0].fileAbsoluteUrl?.match(
          "temprequestid"
        )
      ) {
        setModalOpen(true);
        setModalActive(true);
        if (
          moveAttachmentResponse === "204" ||
          moveAttachmentResponse === "empty"
        ) {
          if (attachmentsArray.length > indexAttachment) {
            dispatch(
              postAttachmentToMoveFileAction(attachmentsArray[indexAttachment])
            );
          }
          if (moveAttachmentResponse === "204") {
            let data: any = {
              attachmentName: attachmentsArray[indexAttachment - 1].fileName,
              fileAbsoluteUrl: `attachments/requestid-${updateCreateToolResponse}/${
                attachmentsArray[indexAttachment - 1].fileName
              }`,
            };
            let updatedArray: any = [...arrayAttachment, data];
            setArrayAttachment(updatedArray);
          }
          setIndexAttachment(indexAttachment + 1);
        }

        dispatch(succespostAttachmentMoveFileAction(""));
      }
    };
    setTimeout(attachmentMove, 1000);
  }, [updateCreateToolResponse, moveAttachmentResponse === "204"]);
  useEffect(() => {
    if (attachmentsArray != undefined) {
      const rowData = { ...row };
      dispatch(
        submitDataAction({
          body: {
            ...rowData,
            attachments: {
              attachment: [...arrayAttachment],
            },
          },
        })
      );
      if (statusSubmit === true) {
        let updatedRow = {
          ...row,
          disposalStatusId: "2",
          attachments: {
            attachment: [...arrayAttachment],
          },
        };
        dispatch(updateDisposalRequestAction(updatedRow));
      } else {
        let updatedRow = {
          ...row,
          disposalStatusId: "1",
          attachments: {
            attachment: [...arrayAttachment],
          },
        };
        dispatch(updateDisposalRequestAction(updatedRow));
      }
    }

    setModalOpen(false);
    setModalActive(false);
    setArrayAttachment([]);
  }, [(attachmentsArray && attachmentsArray.length + 1) === indexAttachment]);

  useEffect(() => {
    if (deleteAttachmentResponse === "204") {
      let data = attachmentRowData.filter(
        (_, index) => index !== deletdAttachment
      );
      const rowData = { ...row };
      dispatch(
        submitDataAction({
          body: {
            ...rowData,
            attachments: {
              attachment: [...data],
            },
          },
        })
      );
      if (row?.requestId) {
        let updatedRow = {
          ...row,
          disposalStatusId: "1",
          attachments: {
            attachment: [...data],
          },
        };
        dispatch(updateDisposalRequestAction(updatedRow));
      }
    }
  }, [deleteAttachmentResponse === "204"]);

  useEffect(() => {
    handleToolNumber(bindingData);
  }, [bindingData]);

  useEffect(() => {
    if (updateCreateToolResponse != undefined) {
      history.replace(`${"/disposal-request/" + updateCreateToolResponse}`);
    }
  }, [updateCreateToolResponse]);

  const handleChangeDebounce = debounce((value) => {
    dispatch(getApproversAction(value));
  }, 1000);

  const handleToolDebounce = debounce((value) => {
    value.length > 2 && dispatch(getNewRequest_toolAction(value));
  }, 1000);

  let filteredapproversValue = approversValue.filter(function (el) {
    return el.mail !== row.requester;
  });
  const updateApprovers = filteredapproversValue.map((item) => {
    return {
      name: item.displayName,
      email: item.mail,
    };
  });

  const eolApprovers = [eolToolingApprover];

  const pgaApprovers = [pgaToolingApprover];

  useEffect(() => {
    if (
      row.approverManagers &&
      row.approverManagers?.approverManager?.length > 0 &&
      !engineeringManagerValue
    ) {
      let approverIndexZero = row.approverManagers.approverManager[0];
      let approverIndexOne = row.approverManagers.approverManager[1];
      let approverIndexTwo = row.approverManagers.approverManager[2];
      let approverIndexThree = row.approverManagers.approverManager[3];

      setEngineeringManagerValue(approverIndexOne);
      setSourcingValue(approverIndexZero);
      if (!pGApproverValue) setPGApproverValue(approverIndexTwo);
      if (!eolToolingSelectValue) setEolToolingSelectValue(approverIndexThree);
    }
  }, [row, engineeringManagerValue]);

  useEffect(() => {
    if (
      eolApprovers.length &&
      (location.pathname === "/disposal-request" ||
        location.pathname === "/disposal-request/")
    ) {
      setEolToolingSelectValue(eolApprovers[0]);
    }
  }, [eolApprovers]);

  useEffect(() => {
    if (
      pgaApprovers.length &&
      (location.pathname === "/disposal-request" ||
        location.pathname === "/disposal-request/")
    ) {
      setPGApproverValue(pgaApprovers[0]);
    }
  }, [pgaApprovers]);

  const handleApproverManagerchange = (options) => {
    const rowData = { ...row };
    let approveMangers: any = [];
    if (rowData?.approverManagers?.approverManager?.length > 0) {
      approveMangers = [...rowData.approverManagers.approverManager];
    }

    if (options.role === "Sourcing Manager") {
      if (approveMangers.length === 0) {
        approveMangers.splice(0, 0, options);
      }
      if (approveMangers.length >= 1) {
        approveMangers[0] = options;
      }
    }
    if (options.role === "Engineering Manager") {
      if (approveMangers.length > 0) {
        if (approveMangers.length === 1) {
          approveMangers.splice(1, 0, null, options);
        }
        if (approveMangers.length >= 2) {
          approveMangers[1] = options;
        }
      } else {
        approveMangers.splice(1, 0, null, options);
      }
    }
    if (options.role === "Service Manager") {
      if (approveMangers.length > 0) {
        if (approveMangers.length === 1) {
          approveMangers.splice(1, 0, null, options);
        }
        if (approveMangers.length === 2) {
          approveMangers.splice(2, 0, options);
        }
        if (approveMangers.length >= 3) {
          approveMangers[2] = options;
        }
      } else {
        approveMangers.splice(1, 0, null, null, options);
      }
    }
    if (options.role === eolToolingApprover.role) {
      if (approveMangers.length > 0) {
        if (approveMangers.length === 1) {
          approveMangers.splice(1, 0, null, null, options);
        }
        if (approveMangers.length === 2) {
          approveMangers.splice(2, 0, null, options);
        }
        if (approveMangers.length === 3) {
          approveMangers.splice(3, 0, options);
        }
        if (approveMangers.length >= 4) {
          approveMangers[3] = options;
        }
      } else {
        approveMangers.splice(1, 0, null, null, null, options);
      }
    }
    let newObj = {};
    newObj["approverManager"] = [...approveMangers];
    rowData.approverManagers = newObj;
    dispatch(
      submitDataAction({
        body: {
          ...rowData,
        },
      })
    );
  };

  const inputRef: any = useRef(null);

  const onClickAttachments = () => {
    inputRef.current.click();
  };

  function handleFileChange(
    file: IAttachments,
    originalRequestId: IAttachments
  ) {
    dispatch(postAttachmentToRequestIdAction({ file, originalRequestId }));
  }

  function handleTempFileChange(
    file: IAttachments,
    tempRequestId: IAttachments
  ) {
    dispatch(postAttachmentToTempFolderAction({ file, tempRequestId }));
  }

  function deleteAttachmentFile(data, index) {
    let splitAttachments = data.fileAbsoluteUrl.split("/");
    if (splitAttachments[1].match("temp")) {
      dispatch(
        postAttachmentDeleteFileAction({
          tempRequestId: splitAttachments[1],
          originalRequestId: "",
          fileName: splitAttachments[2],
          action: "deletefile",
        })
      );

      setDeletdAttachment(index);
    } else {
      dispatch(
        postAttachmentDeleteFileAction({
          tempRequestId: "",
          originalRequestId: splitAttachments[1],
          fileName: splitAttachments[2],
          action: "deletefile",
        })
      );
      setDeletdAttachment(index);
    }
  }
  function downloadAttachmentFile(data, index) {
    let splitAttachments = data.fileAbsoluteUrl.split("/");
    if (splitAttachments[1]?.match("temp")) {
      dispatch(
        gettAttachmentDownloadFileAction({
          tempRequestId: splitAttachments[1],
          originalRequestId: "",
          fileName: splitAttachments[2],
        })
      );
    } else {
      let originalRequest = splitAttachments[1]?.split("-");
      if (originalRequest) {
        dispatch(
          gettAttachmentDownloadFileAction({
            originalRequestId: originalRequest[1] || splitAttachments[1],
            tempRequestId: "",
            fileName: splitAttachments[2],
          })
        );
      }
    }
  }

  const isAttachDisabled = () => {
    return paramsData?.disposalStatusId === "4" || isAttachLoading;
  };

  return (
    <div className={classes.filterWrapper}>
      {modalActive && (
        <CentralLoader open={modalOpen} handleClose={handleClose} />
      )}
      <Box data-tut={"reactour__requestInformation"}>
        <Grid item>
          {" "}
          <RequestHeader header={header} />{" "}
        </Grid>
        <Grid container direction={"column"} spacing={2}>
          {row?.requestId && (
            <Grid item>
              <TextField
                disabled
                fullWidth
                label="Request Id"
                variant="outlined"
                value={"Request Id : " + row.requestId}
              />
            </Grid>
          )}
          {row?.requester && (
            <Grid item>
              <TextField
                disabled
                fullWidth
                required
                label="Requestor"
                variant="outlined"
                value={row.requester}
              />
            </Grid>
          )}
          <Grid item>
            <Autocomplete
              id="business-unit-select"
              disabled={
                paramsData.disposalStatusId === "2" ||
                paramsData.disposalStatusId === "3" ||
                paramsData.disposalStatusId === "4" ||
                (!requester &&
                  (paramsData.disposalStatusId === "3" ||
                    paramsData.disposalStatusId === "4"))
              }
              value={row}
              clearOnBlur
              aria-label={"business-unit-select"}
              fullWidth
              options={businessUnit}
              getOptionLabel={(option) => option.businessUnit}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label="Business Unit"
                  variant="outlined"
                />
              )}
              onChange={(event, options) => {
                if (!options) {
                  return;
                }
                handleBusinessUnit(options.businessUnit);
              }}
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              disabled={
                paramsData.disposalStatusId === "2" ||
                paramsData.disposalStatusId === "3" ||
                paramsData.disposalStatusId === "4" ||
                (!requester &&
                  (paramsData.disposalStatusId === "3" ||
                    paramsData.disposalStatusId === "4"))
                  ? true
                  : false
              }
              value={
                row.reasonForRequest === null ||
                row.reasonForRequest === undefined
                  ? ""
                  : row.reasonForRequest
              }
              inputProps={{maxLength: 500}}
              multiline
              maxRows={4}
              required
              label="Summary - Reason for Request"
              variant="outlined"
              onChange={(event) => handleReasonForRequest(event.target.value)}
            />
          </Grid>
        </Grid>
      </Box>
      {(row.disposalStatusId === "" || row.disposalStatusId === "1") && (
        <Box data-tut={"reactour__approvers"}>
          <Grid item>
            {" "}
            <RequestHeader header={headerApprovers} />{" "}
          </Grid>

          <Grid
            container
            direction={"column"}
            spacing={2}
            data-tut={"reactour__filter-Module"}
          >
            <Grid item>
              <Autocomplete
                id="sourcing-manager-select"
                disabled={
                  paramsData.disposalStatusId === "2" ||
                  paramsData.disposalStatusId === "3" ||
                  paramsData.disposalStatusId === "4" ||
                  (!requester &&
                    (paramsData.disposalStatusId === "3" ||
                      paramsData.disposalStatusId === "4"))
                    ? true
                    : false
                }
                clearOnBlur
                aria-label="sourcing-manager-select"
                fullWidth
                value={sourcingValue}
                options={updateApprovers}
                getOptionLabel={(option: any) => {
                  if (option && typeof option === "object" && option.name) {
                    return `${option.name} (${option.email || ""})`;
                  }
                  return "";
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="Sourcing Manager"
                    variant="outlined"
                    error={
                      validationStatus &&
                      !row?.approverManagers?.approverManager?.[0]?.name
                    }
                  />
                )}
                onChange={(event, options: any) => {
                  setSourcingValue(options);
                  handleApproverManagerchange({
                    ...options,
                    role: "Sourcing Manager",
                  });
                }}
                onInputChange={(event, value) => {
                  if (!value) {
                    return;
                  }
                  handleChangeDebounce(value);
                }}
              />
            </Grid>
            <Grid item>
              <Autocomplete
                id="engineering-manager-select"
                disabled={
                  paramsData.disposalStatusId === "2" ||
                  paramsData.disposalStatusId === "3" ||
                  paramsData.disposalStatusId === "4" ||
                  (!requester &&
                    (paramsData.disposalStatusId === "3" ||
                      paramsData.disposalStatusId === "4"))
                    ? true
                    : false
                }
                clearOnBlur
                aria-label="engineering-manager-select"
                fullWidth
                value={engineeringManagerValue}
                options={updateApprovers}
                getOptionLabel={(option: any) => {
                  if (option && typeof option === "object" && option.name) {
                    return `${option.name} (${option.email || ""})`;
                  }
                  return "";
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="Engineering Manager "
                    variant="outlined"
                    error={
                      validationStatus &&
                      !row?.approverManagers?.approverManager?.[1]?.name
                    }
                  />
                )}
                onChange={(event, options: any) => {
                  setEngineeringManagerValue(options);
                  handleApproverManagerchange({
                    ...options,
                    role: "Engineering Manager",
                  });
                }}
                onInputChange={(event, value) => {
                  if (!value) {
                    return;
                  }
                  handleChangeDebounce(value);
                }}
              />
            </Grid>
            <Grid item>
              <Autocomplete
                id="service-manager-select"
                disabled={
                  paramsData.disposalStatusId === "2" ||
                  paramsData.disposalStatusId === "3" ||
                  paramsData.disposalStatusId === "4" ||
                  (!requester &&
                    (paramsData.disposalStatusId === "3" ||
                      paramsData.disposalStatusId === "4")) ||
                  pGApproverValue?.email
                    ?.toLowerCase()
                    ?.includes(pgaToolingApprover.email)
                }
                clearOnBlur
                aria-label="service-manager-select"
                fullWidth
                value={pGApproverValue}
                options={pgaApprovers}
                getOptionLabel={(option: any) => {
                  if (option && typeof option === "object" && option.name) {
                    return `${option.name} (${option.email || ""})`;
                  }
                  return "";
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="PG&A Approver"
                    variant="outlined"
                    error={
                      validationStatus &&
                      !row?.approverManagers?.approverManager?.[2]?.name
                    }
                  />
                )}
                onChange={(event, options) => {
                  setPGApproverValue(options);
                  if (options) {
                    handleApproverManagerchange({
                      ...options,
                      role: pgaToolingApprover.role,
                    });
                  } else {
                    // Handle clearing the selection
                    handleApproverManagerchange({
                      name: null,
                      email: null,
                      role: pgaToolingApprover.role,
                    });
                  }
                }}
                onInputChange={(event, value) => {
                  if (!value) {
                    return;
                  }
                  handleChangeDebounce(value);
                }}
              />
            </Grid>
            <Grid item>
              <Autocomplete
                id="eol-tooling-select"
                disabled={
                  paramsData.disposalStatusId === "2" ||
                  paramsData.disposalStatusId === "3" ||
                  paramsData.disposalStatusId === "4" ||
                  (!requester &&
                    (paramsData.disposalStatusId === "3" ||
                      paramsData.disposalStatusId === "4")) ||
                  eolToolingSelectValue?.email
                    ?.toLowerCase()
                    ?.includes(eolToolingApprover.email)
                }
                clearOnBlur
                aria-label={"eol-tooling-select"}
                fullWidth
                value={eolToolingSelectValue}
                options={eolApprovers}
                getOptionLabel={(option: any) => {
                  if (option && typeof option === "object" && option.name) {
                    return `${option.name} (${option.email || ""})`;
                  }
                  return "";
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label={eolToolingApprover.role}
                    variant="outlined"
                  />
                )}
                onChange={(event, options) => {
                  setEolToolingSelectValue(options);
                  if (options) {
                    handleApproverManagerchange({
                      ...options,
                      role: eolToolingApprover.role,
                    });
                  } else {
                    // Handle clearing the selection
                    handleApproverManagerchange({
                      name: null,
                      email: null,
                      role: eolToolingApprover.role,
                    });
                  }
                }}
                onInputChange={(event, value) => {
                  if (!value) {
                    return;
                  }
                  handleChangeDebounce(value);
                }}
              />
            </Grid>
          </Grid>
        </Box>
      )}

      <Grid item>
        {" "}
        <RequestHeader header={headerAttachments} />{" "}
      </Grid>

      <Grid
        container
        direction={"column"}
        spacing={1}
        data-tut={"reactour__filter-Module"}
      >
        <Grid item>
          <input
            style={{ display: "none" }}
            ref={inputRef}
            type="file"
            onChange={(e: any) => {
              if (row?.requestId) {
                handleFileChange(e?.target?.files?.[0], row.requestId);
              } else {
                handleTempFileChange(e?.target?.files?.[0], guiID);
              }
            }}
          />
          <Button
            data-tut={"reactour__attach"}
            variant="contained"
            color="primary"
            disabled={isAttachDisabled()}
            onClick={onClickAttachments}
            startIcon={<AttachFileIcon />}
          >
            {isAttachLoading ? (
              <Box mt={1}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>Uploading...</Grid>
                  <Grid item>
                    <CircularProgress color={"inherit"} size={"1.5rem"} />
                  </Grid>
                </Grid>
              </Box>
            ) : (
              "ATTACH"
            )}
          </Button>
        </Grid>
        {row?.attachments?.attachment?.map((e, index) => (
          <Box
            key={index + e?.attachmentName}
            mt={1}
            sx={{ boxShadow: " 2px 4px  rgb(235, 241, 247)" }}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>{e.attachmentName}</Grid>
              <Grid item>
                <Grid direction="row" alignItems="center" container>
                  <Box>
                    <IconButton
                      color={"primary"}
                      onClick={() => downloadAttachmentFile(e, index)}
                    >
                      <CloudDownloadIcon />
                    </IconButton>
                  </Box>
                  <Box>
                    <IconButton
                      color={
                        paramsData.disposalStatusId === "2" ||
                        paramsData.disposalStatusId === "3" ||
                        paramsData.disposalStatusId === "4"
                          ? "secondary"
                          : "primary"
                      }
                      onClick={() =>
                        paramsData.disposalStatusId === "2" ||
                        paramsData.disposalStatusId === "3" ||
                        paramsData.disposalStatusId === "4"
                          ? console.log("")
                          : deleteAttachmentFile(e, index)
                      }
                    >
                      <DeleteForeverIcon />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        ))}
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    autocompleteNoOptions: {
      color: theme.palette.text.primary,
    },
    inputLabel: {
      padding: theme.spacing(0.5, 0.5, 0),
    },
    clearFilterContainer: {
      marginTop: theme.spacing(2.5),
      display: "flex",
    },
    filterWrapper: {
      "& .MuiAutocomplete-noOptions": {
        color: theme.palette.text.primary,
      },
      margin: theme.spacing(0, 1, 0, 0),
      "& .MuiFormLabel-root": {
        color: theme.palette.secondary.main,
      },
    },
    inputField: {
      width: "6.25rem",
    },
    switch: {
      "& .MuiFormControlLabel-label": {
        lineHeight: "1",
      },
    },
    toggle: {
      margin: theme.spacing(0, 1),
    },
  })
);
